import React, { useState } from 'react';
import Layout from '../components/Layout';
import { FaMoneyBill } from 'react-icons/fa';
import SearchContainer from '../components/SearchContainer';
import FinancialInfo from '../components/FinancialInfo';

const associados = [
  "Claudia Oliveira",
  "Henrique Diniz Junior",
  "Bruno Lisboa Silva",
  "Rafaela Soares Lopes", 
  "Lucas Meireles Souza"
];

function Associados() {
  const [searchTerm, setSearchTerm] = useState('');
  const isMobile = window.innerWidth < 768;

  const filteredAssociados = associados.filter(nome =>
    nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout title="Financeiro Clube" icon={FaMoneyBill}>
      {/* Container principal responsivo */}
      <div style={isMobile ? styles.mobileContainer : styles.desktopContainer}>
        <SearchContainer 
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        {/* Lista de associados */}
        <div style={styles.listaContainer}>
          {filteredAssociados.map((nome, index) => (
            <FinancialInfo key={index} nome={nome} />
          ))}
        </div>
      </div>
    </Layout>
  );
}

const styles = {
  // Estilo para mobile
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
    gap: '20px'
  },
  
  // Estilo para desktop 
  desktopContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    gap: '20px'
  },
  
  // Container da lista
  listaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%'
  }
};

export default Associados;